import { GeneralModel } from "./general.model";

export class ServiceDVGT extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/serviceDVGT.model.ts